import { ReactComponent as IconExportacao } from '../../images/icons/iconeExportacao.svg';
import { ReactComponent as IconImportacao } from '../../images/icons/iconeImportacao.svg';
import { TrackingSys } from '../../constants/TrackingSys';

export const RoutesReportPending = [
    {
      href: "/pendingImports",
      title: "Relatório de Importação",
      trackingSysId: TrackingSys.IMPORT_MILESTONES,
      titleReport: "titleImportMilestones",
      icon: <IconExportacao/>
    },
    {
      href: "/pendingExports",
      title: "Relatório de Exportação",
      trackingSysId: TrackingSys.EXPORT_MILESTONES,
      titleReport: "titleExportMilestones",
      icon: <IconImportacao/>
    }
  ];